module.exports = __webpack_public_path__ + "img/speakers.f078baba.webp";